// Pure filtering logic shared by the provider-search-filters Stimulus
// controller and its node:test suite.

// sex: "" (Any) or an NPPES provider sex code ("F" / "M"). When set, only
// results carrying that exact code stay visible; organizations and results
// without a code are hidden, since they can't be said to match.
export function providerMatchesFilters(provider, { activeOnly, hiddenAppearances = [], sex = "" }) {
  if (activeOnly && provider.likelyActive === "false") return false
  if (sex && (provider.providerSex || "").toUpperCase() !== sex) return false

  const appearance = provider.searchAppearance?.toLowerCase()
  if (appearance && hiddenAppearances.includes(appearance)) return false

  return true
}

export function visibleProviderIndexes(providers, filters) {
  return providers
    .filter((provider) => providerMatchesFilters(provider, filters))
    .map((provider) => provider.providerResultIndex)
    .filter((index) => index !== undefined)
}
